import { getSupportedResolutions } from 'CHECKS/camera/resolutions';
import { onUnhandledError } from 'UTILS/callbacks'

export const DEFINITIONS_TO_TEST = [1080, 720, 480, 360, 180];
export const MIN_REQUIRED_DEFINITION = 240;
export const MIN_RECOMMENDED_DEFINITION = 480;

const start = async({
  onError = () => {},
  onWarning = () => {},
  onSuccess = () => {},
  onEnd = () => {},
  deviceId,
  logger,
}) => {
  try {
    const bestResolution = await getSupportedResolutions({
      deviceId,
      logger,
      resolutions: DEFINITIONS_TO_TEST,
    });
    if (bestResolution < MIN_REQUIRED_DEFINITION) {
      onError('definition_too_low', { bestResolution, minRequiredResolution: MIN_REQUIRED_DEFINITION, minRecommendedResolution: MIN_RECOMMENDED_DEFINITION });
    } else if (bestResolution < MIN_RECOMMENDED_DEFINITION) {
      onWarning('definition_low', { bestResolution, minRequiredResolution: MIN_REQUIRED_DEFINITION, minRecommendedResolution: MIN_RECOMMENDED_DEFINITION });
    } else if (bestResolution) {
      onSuccess('definition_high_enough', { bestResolution });
    } else if (!bestResolution) {
      onError('definition_too_low', { bestResolution: '?', minRequiredResolution: MIN_REQUIRED_DEFINITION, minRecommendedResolution: MIN_RECOMMENDED_DEFINITION });
    }
  } catch (err) {
    switch (err.name) {
      case 'OverconstrainedError':
      case 'NotFoundError':
        onError('camera_not_detected');
        break;
      case 'AbortError':
      case 'NotReadableError':
        onError('camera_not_available');
        break;
      case 'NotAllowedError':
        // TODO: What should we do here? (ie. the user removed the permissions after accepting them first)
        break;
      default:
        onUnhandledError(err);
        onError('definition_check_impossible');
    }
  } finally {
    onEnd();
  }
};

export default {
  start,
};
